import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { Row, Col, Button, Grid, Carousel } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { JoinClassName } from 'src/utils/utils';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

const { useBreakpoint } = Grid;

const CommonProductFeatureSection = ({ title, desc, className, children, outerClassName = '' }) => {
  const screens = useBreakpoint();
  return (
    <React.Fragment>
      <div
        className={JoinClassName(
          indexStyles.commonProductFeatureWrapper,
          outerClassName,
          screens.xs ? indexStyles.forMobile : '',
          screens.md ? indexStyles.forMDDevice : '', //768
          screens.sm && !screens.md ? indexStyles.forSMDevice : '' //576
        )}
      >
        <div
          className={JoinClassName(
            indexStyles.commonSection,
            title ? '' : indexStyles.commonSectionNoHeader,
            className,
            screens.xs ? indexStyles.mobile : ''
          )}
        >
          {title && (
            <Row align={'middle'} justify={'center'} wrap={false}>
              <Col xs={22} md={16} xl={21}>
                {title && <h2 className={JoinClassName(indexStyles.title_h2)}>{title}</h2>}
              </Col>
            </Row>
          )}

          {desc && (
            <Row align={'middle'} justify={'center'} wrap={false}>
              <Col xs={22} md={16}>
                <p className={JoinClassName(indexStyles.commonProductFeatureDesc)}>{desc}</p>
              </Col>
            </Row>
          )}

          {(title || desc) && (
            <Row align={'middle'} justify={'center'} wrap={false}>
              <Col
                xs={22}
                md={16}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 15 }}
              >
                <Link href="/get-a-demo">
                  <a>
                    <Button
                      shape="round"
                      type="primary"
                      size="large"
                      className="get-a-demo-button-middle"
                      style={{
                        paddingTop: 0,
                        paddingBottom: 0,
                      }}
                    >
                      <FormattedMessage id="home.get-demo.bitton" />
                    </Button>
                  </a>
                </Link>
              </Col>
            </Row>
          )}

          <Row align={'middle'} justify={'center'} wrap={false}>
            <Col xs={24}>{children}</Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CommonProductFeatureSection;
